import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from '../useStyles';

interface Props {
  message: string;
}

export const LoadingCard = ({ message }: Props) => {
  const styles = useStyles();
  return (
    <CustomTypography
      variant={TYPOGRAPHY_VARIANT.regular14}
      className={styles.body}
    >
      {message}
    </CustomTypography>
  );
};
